import React from 'react';
import { useOverviewContext } from '../../hooks/useOverviewContext';
import { NewMembers } from '../NewMembers/NewMembers';
import { TopComments } from '../TopComments/TopComments';
import { EventsSkeleton } from './EventsSkeleton';
import * as S from './styled';
export const Events = () => {
    const overview = useOverviewContext();
    if (overview.isLoading ||
        overview.hasAnyTier === null ||
        overview.membersCount === null ||
        overview.topComments === null)
        return React.createElement(EventsSkeleton, null);
    if (overview.hasAnyTier === false)
        return null;
    if (overview.topComments.length === 0 && overview.membersCount === 0)
        return null;
    if (overview.onboarding.active)
        return null;
    return (React.createElement(S.Container, null,
        React.createElement(TopComments, null),
        React.createElement(NewMembers, null)));
};
